import { RoleEnum, useauthMeQuery } from '@/types/generated/graphql';

export const useUserRole = () => {
  const authMeResult = useauthMeQuery();
  const role = (authMeResult?.data?.authMe?.data?.userWorkspaceRole?.[0]?.role?.slug as RoleEnum) ?? RoleEnum?.member;
  const isMember = role === RoleEnum?.member;
  return { role, isMember };
};
